/**
 * The contents of a linked-resource row: its icon, what it is, and its
 * identifier.
 *
 * Separate from the row itself because the row has four shapes — internal
 * link, external link, inert, disabled — and all four render this identically.
 */
import type { ReactNode } from 'react';

export interface ReviewLinkBodyProps {
  icon: ReactNode;
  label: string;
  value: string;
  hint?: string | null;
  disabled?: boolean;
}

export default function ReviewLinkBody({
  icon,
  label,
  value,
  hint,
  disabled,
}: ReviewLinkBodyProps) {
  return (
    <>
      <span
        style={{
          flex: '0 0 28px',
          width: 28,
          height: 28,
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: disabled ? 'var(--nb-surface)' : 'var(--nb-primary-soft)',
          color: disabled ? 'var(--nb-faint)' : 'var(--nb-primary-2)',
        }}
      >
        {icon}
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span
          style={{
            display: 'block',
            fontSize: 12.5,
            fontWeight: 700,
            color: disabled ? 'var(--nb-faint)' : 'var(--nb-ink)',
          }}
        >
          {label}
        </span>
        <span
          className="nb-mono"
          style={{ display: 'block', fontSize: 11, color: 'var(--nb-subtle)' }}
        >
          {value}
        </span>
        {hint && (
          <span style={{ display: 'block', fontSize: 10.5, color: 'var(--nb-faint)' }}>{hint}</span>
        )}
      </span>
    </>
  );
}
